export const DEFAULT_DESKTOP_WIDTH = 1200;
export const DEFAULT_TABLET_LANDSCAPE_WIDTH = 992;
export const DEFAULT_TABLET_VERTICAL_WIDTH = 768;
export const DEFAULT_MOBILE_WIDTH = 390;
export const DEFAULT_LEFT_RIGHT_SHOWBAR_WIDTH = 500;
export const DEFAULT_CANVAS_WIDTH = 780;
export const DEFAULT_CANVAS_HEIGHT = 519;

export const DESKTOP = 'Desktop';
export const TABLET_LANDSCAPE = 'TabletLandscape';
export const TABLET_VERTICAL = 'TabletVertical';
export const MOBILE = 'Mobile';

export const RESTRICT_FILE_SIZE = 2.0;
export const RESTRICT_FILE_SIZE_VIDEO = 10.0;
export const RESTRICT_FILE_SIZE_KB = 20.0;
export const PAGE_NAME_AVOIDED_CHARS = /[`!$@#%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/;
export const WIDGET_NAME_AVOIDED_CHARS = /[ `!$@#%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
export const PAGE_URL_AVOIDED_CHARS = /[ `A-Z!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/;
export const HELP_LINK = 'https://docs.openweaver.com/studio/userguide.html';
export const WHATSAPP_LINK = 'https://api.whatsapp.com/send?phone=919360959396';
export const GEN_AI_CONTENT_TOOL =
  'https://genaicontenttool-app.openweaver.com';
  export const GENERATIVE_APP_V2 =
  '/generate-app';
export const BROWSE_IMAGE_PER_PAGE = 40;
export const PACKAGE_NAME_PER_PAGE = 10;

export const DEFAULT_WIDGET_PANEL_SIZE = 67;
export const DEFAULT_PAGE_PANEL_SIZE = 33;
export const DYNAMIC_ADJUSTMENT_PANEL_DIFF = 52;

export const PIXELGRIDCOLOR = 'pixelGridColor';
export const PIXELGRIDOPACITY = 'pixelGridOpacity';
export const PIXELGRIDSIZE = 'pixelGridSize';
export const SHOWGUIDELINES = 'showGuidelines';
export const SHOWPIXELGRID = 'showPixelGrid';
export const SNAPTOPIXELGRID = 'snapToPixelGrid';

export const IMAGEDEFAULTSIZE = '200';

export const GCP_STORAGE_PATH = 'https://storage.googleapis.com/';
export const PAGETEMPLATE_LIST = '/pagetemplate-listing/page-template';
export const SECTIONTEMPLATE_LIST = '/pagetemplate-listing/section-template';
export const APPTEMPLATE_LIST = '/pagetemplate-listing/app-template';
export const DESKTOPRES = 'widgetStyleDtls';
export const LEFT_TOP = 'left top';
export const CENTER_TOP = 'center top';
export const RIGHT_TOP = 'right top';
export const LEFT_CENTER = 'left center';
export const CENTER = 'center';
export const RIGHT_CENTER = 'right center';
export const LEFT_BOTTOM = 'left bottom';
export const CENTER_BOTTOM = 'center bottom';
export const RIGHT_BOTTOM = 'right bottom';
export const FLOAT_FRONT = 'front';
export const FLOAT_BACK = 'back';
export const isRestrictToMoveWidgets = ['FloatingBox', 'SlideBlock'];
export const POSITION_ABSOLUTE = 'Absolute';
export const POSITION_RELATIVE = 'Relative';
export const RELATIVE = 'Relative';
export const ABSOLUTE = 'absolute';
export const AUTO_FIT = 'auto-fit';
export const AUTO_FILL = 'auto-fill';
export const VIEWPORT = 'ViewPort';
export const LEFT = 'left';
export const RIGHT = 'right';
export const TOP = 'top';
export const BOTTOM = 'bottom';
export const SMALL_ALPHAS = 'abcdefghijklmnopqrstuvwxyz';
export const NUMBERS = '0123456789';

export const WIDGET_LENGTH_LIMIT = 20;

export const CommonConstants = {
  DESKTOP,
  TABLET_LANDSCAPE,
  TABLET_VERTICAL,
  MOBILE,
  DEFAULT_DESKTOP_WIDTH,
  DEFAULT_TABLET_LANDSCAPE_WIDTH,
  DEFAULT_TABLET_VERTICAL_WIDTH,
  DEFAULT_MOBILE_WIDTH,
  DEFAULT_LEFT_RIGHT_SHOWBAR_WIDTH,
  DEFAULT_CANVAS_WIDTH,
  RESTRICT_FILE_SIZE,
  PAGE_NAME_AVOIDED_CHARS,
  WIDGET_NAME_AVOIDED_CHARS,
  PAGE_URL_AVOIDED_CHARS,
  HELP_LINK,
  WHATSAPP_LINK,
  GEN_AI_CONTENT_TOOL,
  BROWSE_IMAGE_PER_PAGE,
  SNAPTOPIXELGRID,
  SHOWPIXELGRID,
  SHOWGUIDELINES,
  PIXELGRIDSIZE,
  PIXELGRIDCOLOR,
  PIXELGRIDOPACITY,
  IMAGEDEFAULTSIZE,
  GCP_STORAGE_PATH,
  RESTRICT_FILE_SIZE_KB,
  PAGETEMPLATE_LIST,
  SECTIONTEMPLATE_LIST,
  APPTEMPLATE_LIST,
  DEFAULT_CANVAS_HEIGHT,
  RESTRICT_FILE_SIZE_VIDEO,
  DESKTOPRES,
  LEFT_TOP,
  CENTER_TOP,
  RIGHT_TOP,
  LEFT_CENTER,
  CENTER,
  RIGHT_CENTER,
  LEFT_BOTTOM,
  CENTER_BOTTOM,
  RIGHT_BOTTOM,
  FLOAT_FRONT,
  FLOAT_BACK,
  isRestrictToMoveWidgets,
  POSITION_ABSOLUTE,
  POSITION_RELATIVE,
  RELATIVE,
  ABSOLUTE,
  AUTO_FILL,
  AUTO_FIT,
  VIEWPORT,
  LEFT,
  RIGHT,
  TOP,
  BOTTOM,
  SMALL_ALPHAS,
  NUMBERS,
  WIDGET_LENGTH_LIMIT,
  GENERATIVE_APP_V2
};

export const styleUsedProps = {
  widgetStyleDtls: 'usedProps',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeUsedProps',
  tabPortraitWidgetStyleDtls: 'tabPortraitUsedProps',
  mobileWidgetStyleDtls: 'mobileUsedProps',
};

export const transformSizeBasedOnDevice = {
  widgetStyleDtls: 'transformSize',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTransformSize',
  tabPortraitWidgetStyleDtls: 'tabPortraitTransformSize',
  mobileWidgetStyleDtls: 'mobileTransformSize',
};

export const widgetStyleDtlsDeviceType = {
  widgetStyleDtls: DESKTOPRES,
  tabLandscapeWidgetStyleDtls: 'tabLandscapeWidgetStyleDtls',
  tabPortraitWidgetStyleDtls: 'tabPortraitWidgetStyleDtls',
  mobileWidgetStyleDtls: 'mobileWidgetStyleDtls',
};

export const responsiveVisibilityDeviceTypeConstant = {
  widgetStyleDtls: 'desktop',
  tabLandscapeWidgetStyleDtls: 'tabletLandscape',
  tabPortraitWidgetStyleDtls: 'tabletPortrait',
  mobileWidgetStyleDtls: 'mobile',
};

export const transformBasedOnDevice = {
  widgetStyleDtls: 'transform',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTransform',
  tabPortraitWidgetStyleDtls: 'tabPortraitTransform',
  mobileWidgetStyleDtls: 'mobileTransform',
};
export const transformContentBasedOnDevice = {
  widgetStyleDtls: 'transformRepeatorContent',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTransform',
  tabPortraitWidgetStyleDtls: 'tabPortraitTransform',
  mobileWidgetStyleDtls: 'mobileTransform',
};
export const transformScrollBasedOnDevice = {
  widgetStyleDtls: 'transformScroll',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTransform',
  tabPortraitWidgetStyleDtls: 'tabPortraitTransform',
  mobileWidgetStyleDtls: 'mobileTransform',
};
export const transformPaginationBasedOnDevice = {
  widgetStyleDtls: 'transformPagination',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTransform',
  tabPortraitWidgetStyleDtls: 'tabPortraitTransform',
  mobileWidgetStyleDtls: 'mobileTransform',
};

export const transformScrollBarBasedOnDevice = {
  widgetStyleDtls: 'transformScrollBar',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTransform',
  tabPortraitWidgetStyleDtls: 'tabPortraitTransform',
  mobileWidgetStyleDtls: 'mobileTransform',
};

export const fonstStylePropsBasedOnDevice = {
  widgetStyleDtls: 'fontstyle',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeFontstyle',
  tabPortraitWidgetStyleDtls: 'tabPortraitFontstyle',
  mobileWidgetStyleDtls: 'mobileFontstyle',
};
export const textStylePropsBasedOnDevice = {
  widgetStyleDtls: 'textStyle',
  tabLandscapeWidgetStyleDtls: 'tabLandscapeTextstyle',
  tabPortraitWidgetStyleDtls: 'tabPortraitTextstyle',
  mobileWidgetStyleDtls: 'mobileTextstyle',
};
export const isRestrictAlignToParent = ['FloatingBox', 'SlideBlock'];

export const defaultImageName='/images/defaultimage.webp';

